// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.openeo-vue-tooltip{display:inline-block;position:absolute;background-color:#333;color:#fff;padding:5px;border-radius:5px;z-index:9999;font-size:.9em;border:1px solid #000;text-align:center;max-width:250px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
